import { Alert, AlertTitle, Grid, Paper, Snackbar,Tooltip, useMediaQuery } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux/es/exports";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import CustomDateField from "../CustomComponents/CustomDateField";
import CustomTextField from "../CustomComponents/CustomTextField";
import { SecurityChequeReducerAction } from "../Store/SecurityCheque/SecurityChequeReducer";
import store from "./../Store/index";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

const SecurityChequeInfo = (props) => {
  const chequeDetailData = useSelector(
    (state) => state.securityCheque.chequeDetailData
  );

  const filterValues = useSelector(
    (state) => state.securityCheque.filterValues
  );

  const userName = useSelector((state) => state.branch.userName);
  //Getting value from the store
  const touchHandler = useSelector(
    (state) => state.securityCheque.touchHandler
  );
  const valueIsValid = useSelector(
    (state) => state.securityCheque.valueIsValid
  );

  const chequeNumHasError =
    touchHandler.startChequeNumberTouched &&
    !valueIsValid.startChequeNumberIsValid;

  const chequeTypeHasError =
    touchHandler.chequeTypeTouched && !valueIsValid.chequeTypeIsValid;

  const numOfChequesHasError =
    touchHandler.noOfChequeTouched && !valueIsValid.noOfChequeIsValid;

  const micrTypeHasError =
    touchHandler.micrTypeTouched && !valueIsValid.micrTypeIsValid;
  const bankOptionTypeHasError =
    touchHandler.bankOptionTouched && !valueIsValid.bankOptionIsValid;

  const micrNumberHasError =
    touchHandler.micrNumberTouched && !valueIsValid.micrNumberIsValid;

  const drawerBankHasError =
    touchHandler.drawerBankTouched && !valueIsValid.drawerBankIsValid;

  const drawerBranchHasError =
    touchHandler.drawerBranchTouched && !valueIsValid.drawerBranchIsValid;

  const ifscHasError = touchHandler.ifscTouched && !valueIsValid.ifscIsValid;

  const accNumHasError =
    touchHandler.accNumberTouched && !valueIsValid.accNumberIsValid;

  const accHolderNameHasError =
    touchHandler.accHolderNameTouched && !valueIsValid.accHolderNameIsValid;

  const repayAmtHasError =
    touchHandler.repayAmtTouched && !valueIsValid.repayAmtIsValid;

  const chequeAmtHasError =
    touchHandler.chequeAmtTouched && !valueIsValid.chequeAmtIsValid;

  //Creating Dispatch
  const dispatch = useDispatch();

  const [chequeNumErrorMsg, setChequeNumErrorMsg] = useState(
    "Please Enter Start Cheque Number"
  );
  const [noOfChequesErrorMsg, setNumberOfChequesErrorMsg] = useState(
    "Please Enter Number of Cheques"
  );

  // Dialog msg content.
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogTitleMessage, setDialogTitleMessage] = useState("");
  const [open, setOpen] = useState(false);

  const [duplicateChequeResponseData, setDuplicateChequeResponseData] = useState();

  //SnackBar Handler
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [snackBarState, setSnackBarState] = React.useState({
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal } = snackBarState;
  const [alert, setAlert] = useState(false);

  const deviceModeValue = useMediaQuery("(max-width:1200px)");
  useEffect(() => {
    // true -> mobile or tab, false -> desktop
    let SnackPosition = {
      vertical: deviceModeValue ? "top" : "bottom",
      horizontal: deviceModeValue ? "right" : "left",
    };
    setSnackBarState(SnackPosition);
  }, []);

  useEffect(() => {
    dispatch(SecurityChequeReducerAction.updateMICRTypeValue("MICR"));
    const getFileDetails = async () => {
      const fileDetailReponse = await axios.post(
        "/securityCheque/getFileDetails",
        {
          applicationNum: filterValues.applicationNum,
        }
      );
      if (fileDetailReponse.data.length > 0) {
        let fileData = fileDetailReponse.data[0];
        dispatch(
          SecurityChequeReducerAction.updateRepayAmt(fileData.sanctionedEmiAmt)
        );
      }
    };
    if (filterValues.losStatus === "Sanctioned") {
      // for sancationed calculate the emi amount
      const sanctionAmt = filterValues.sanctionAmt;
      let time = filterValues.tenure;
      // yearly rate of interest
      let rateOfInterest = filterValues.rateOfInterest;
      // monthly converted rate of interest
      rateOfInterest = rateOfInterest / (12 * 100);
      let montlyPayment =
        (sanctionAmt * rateOfInterest * Math.pow(1 + rateOfInterest, time)) /
        (Math.pow(1 + rateOfInterest, time) - 1);
      dispatch(
        SecurityChequeReducerAction.updateRepayAmt(Math.ceil(montlyPayment))
      );
    } else {
      getFileDetails();
    }

    return () => {
      // create a copy of cheque detail data on reducer for cheque Info before reset.
      const chequeDetailDataInfo =
        store.getState().securityCheque.chequeDetailData;
      dispatch(
        SecurityChequeReducerAction.updateChequeDetailsInfo(
          chequeDetailDataInfo
        )
      );
      dispatch(SecurityChequeReducerAction.resetChequeDetailValues());
    };
  }, []);

  const removeUnwantedChars = (inputValue, typeValue) => {
    const regExpString =
      /^(?=\n)$|^\s*|^\s*$(?:\r\n?|\n)|\n\n+|\t|[^a-zA-Z0-9.,]|[%<>\\$'"{}\[\]]/gim;
    let formattedValue = String(inputValue).replace(regExpString, " ");
    // we need to remove twice since relaced space shouldbe removed
    formattedValue = String(formattedValue).replace(/[^\u0000-\u007F]+/, "");
    let finalValue = String(formattedValue).replace(regExpString, " ");
    finalValue = finalValue.replace(/\s+/g, " ");
    finalValue = finalValue.trimStart();
    // remove the starting space, comma, dot at starting position of string only.
    if (finalValue.startsWith(",") || finalValue.startsWith(".")) {
      finalValue = finalValue.replace(/,+/g, ",");
      finalValue = finalValue.replace(/,/, "");
      finalValue = finalValue.replace(/\.+/g, ".");
      finalValue = finalValue.replace(/\./, "");
    }

    if (typeValue === "accNumber") {
      dispatch(SecurityChequeReducerAction.updateAccountNumValue(finalValue));
    }
  };

  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };

  const onChangeChequeNumber = async () => {
    const newValue = chequeDetailData.startChequeNumber;
    // check for decimal point & negative value -> consider it as invalid value.
    setChequeNumErrorMsg(
      newValue === null || newValue === undefined || newValue === ""
        ? "Please Enter Start Cheque Number"
        : newValue.length > 6 ||
          newValue.length < 6 ||
          String(newValue).includes(".") ||
          Number(newValue) < 0
        ? "Please Enter Valid Cheque Number"
        : ""
    );
    if (
      newValue !== "" &&
      newValue !== null &&
      newValue !== undefined &&
      newValue.length === 6 &&
      !String(newValue).includes(".") &&
      Number(newValue) > 0
    ) {
      dispatch(SecurityChequeReducerAction.updateStartChequeNumber(newValue));
      // validate for the duplicate exist from backend.
      try {
        // get the application num from the grid.
        const duplicateChequeResponse = await axios.post(
          "/securityCheque/duplicateChequeNumberCheck",
          {
            applicationNum: filterValues.applicationNum,
            chequeNumList: [newValue],
          }
        );

        setDuplicateChequeResponseData(duplicateChequeResponse);
        if(duplicateChequeResponse.data.status==="CANCELLED-DUPLICATE"){
          setOpen(true)
          setDialogTitleMessage("Confirmation");
          setDialogMessage(duplicateChequeResponse.data.errorMesage)
        }
        
        if (duplicateChequeResponse.data.status === "PARTIAL_CONTENT") {
          let errorChequeNums = [];
          errorChequeNums = errorChequeNums.concat([
            ...new Set(duplicateChequeResponse.data.receiptChequeNums),
          ]);
          errorChequeNums = errorChequeNums.concat([
            ...new Set(duplicateChequeResponse.data.securityChequeNums),
          ]);
          errorChequeNums = [...new Set(errorChequeNums.sort())];
          setChequeNumErrorMsg(
            duplicateChequeResponse.data.errorMesage + " :  " + errorChequeNums
          );
          dispatch(
            SecurityChequeReducerAction.updateStartChequeNumberErrorHandler(
              true
            )
          );
          // here for below false means the value is invalid due to already it is present.
          dispatch(
            SecurityChequeReducerAction.updateStartChequeNumberIsValid(false)
          );
          setMessage(
            duplicateChequeResponse.data.errorMesage + " :  " + errorChequeNums
          );
          setAlertType("error");
          openAlertHandler();
          return;
        } else {
          setChequeNumErrorMsg("");
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      setChequeNumErrorMsg("Please Enter Valid Cheque Number");
      dispatch(
        SecurityChequeReducerAction.updateStartChequeNumberErrorHandler(true)
      );
    }
  };

  const onChangeBankOption = async (value) => {
    if (value && value !== "" && value === "PRIMARY") {
      const response = await axios.post(
        "/losCustomer/getCustBankDetailsByAppNum",
        {
          applicationNum: filterValues.applicationNum,
        }
      );

      if (response.data.length > 0) {
        const record = response.data[0];
        dispatch(SecurityChequeReducerAction.updateMICRValue(record.micrCode));
        dispatch(
          SecurityChequeReducerAction.updateAccountNumValue(
            record.bankAccountNum
          )
        );
        dispatch(
          SecurityChequeReducerAction.updateAccountHolderNameValue(
            record.accHoldrName
          )
        );
        dispatch(
          SecurityChequeReducerAction.updateDraweeBankValue(record.bankName)
        );
        dispatch(
          SecurityChequeReducerAction.updateDraweeBranchValue(
            record.bankBranchName
          )
        );
        dispatch(SecurityChequeReducerAction.updateIFSCValue(record.ifscCode));
      }
    } else {
      dispatch(SecurityChequeReducerAction.updateMICRValue(""));
      dispatch(SecurityChequeReducerAction.updateAccountNumValue(""));
      dispatch(SecurityChequeReducerAction.updateAccountHolderNameValue(""));
      dispatch(SecurityChequeReducerAction.updateDraweeBankValue(null));
      dispatch(SecurityChequeReducerAction.updateDraweeBranchValue(null));
      dispatch(SecurityChequeReducerAction.updateIFSCValue(""));
    }
  };

  const onChangeDraweerBank = (bankName) => {
    dispatch(SecurityChequeReducerAction.updateDraweeBranchValue(null));
    if (bankName !== null && bankName !== "" && bankName !== undefined) {
      let draweerBanksMap =
        store.getState().securityCheque.chequeDetailData.drawerBankMap;
      const bankData = draweerBanksMap.filter(
        (rec) => rec.bank_name === bankName
      );
      const bankCode = bankData[0].bank_code;
      const getDraweerBanksBranch = async () => {
        try {
          const response = await axios.post(
            "/filereceipt/getDraweerBanksBranch",
            {
              shflApisModel: {
                apiCode: "BANK_BRANCH_LIST_SHFL_API",
                createdBy: userName,
                lastModifiedBy: userName,
              },
              bankCode: bankCode,
            }
          );
          if (Object.keys(response.data).length > 0) {
            if (Number(response.data.status) === 1) {
              const branchLists = response.data.branch_list;
              const branchNames = branchLists.map((rec) => rec.branch_name);
              dispatch(
                SecurityChequeReducerAction.updateDraweeBranchArray(branchNames)
              );
              dispatch(
                SecurityChequeReducerAction.updateDraweeBranchMap(branchLists)
              );
            } else {
              dispatch(SecurityChequeReducerAction.updateDraweeBranchArray([]));
              dispatch(SecurityChequeReducerAction.updateDraweeBranchMap([]));
            }
          }
        } catch (error) {
          console.log(error);
          throw Error(error);
        }
      };
      getDraweerBanksBranch();
      dispatch(SecurityChequeReducerAction.updateDraweeBankValue(bankName));
    } else {
      dispatch(SecurityChequeReducerAction.updateDraweeBranchArray([]));
      dispatch(SecurityChequeReducerAction.updateDraweeBranchMap([]));
      dispatch(SecurityChequeReducerAction.updateDraweeBankValue(null));
      dispatch(SecurityChequeReducerAction.updateDraweeBranchValue(null));
    }
  };

  const onChangeNumberOfCheques = async () => {
    const newValue = chequeDetailData.noOfCheque;
    setNumberOfChequesErrorMsg(
      newValue === null ||
        newValue === undefined ||
        newValue === "" ||
        newValue === 0 ||
        newValue === "0"
        ? "Please Enter Number of Cheques"
        : newValue.length > 2 ||
          Number(newValue) < 0 ||
          String(newValue).includes(".")
        ? "Please Enter Valid Number of Cheques"
        : ""
    );
    if (
      newValue !== "" &&
      newValue !== null &&
      newValue !== undefined &&
      Number(newValue) !== 0 &&
      Number(newValue) > 0 &&
      newValue.length < 3 &&
      !String(newValue).includes(".")
    ) {
      dispatch(SecurityChequeReducerAction.updateNumberOfCheques(newValue));
      setNumberOfChequesErrorMsg("");
    } else {
      setNumberOfChequesErrorMsg("Please Enter Valid Number of Cheques");
      dispatch(
        SecurityChequeReducerAction.updateNumOfChequesErrorHandler(true)
      );
    }
  };

  //Dialog 
  const handleClose = () => {
    let errorChequeNums = [];
      errorChequeNums = errorChequeNums.concat([
        ...new Set(duplicateChequeResponseData.data.receiptChequeNums),
      ]);
      errorChequeNums = errorChequeNums.concat([
        ...new Set(duplicateChequeResponseData.data.securityChequeNums),
      ]);
      errorChequeNums = [...new Set(errorChequeNums.sort())];
      setChequeNumErrorMsg(
        "Cheque Numbers are already present :  " + errorChequeNums
      );
      dispatch(
        SecurityChequeReducerAction.updateStartChequeNumberErrorHandler(
          true
        )
      );
      // here for below false means the value is invalid due to already it is present.
      dispatch(
        SecurityChequeReducerAction.updateStartChequeNumberIsValid(false)
      );
      setMessage(
          "Cheque Numbers are already present :  " + errorChequeNums
      );
      setAlertType("error");
      openAlertHandler();
      setOpen(false);
  };

  const handleOk = () => {
    setChequeNumErrorMsg("");
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Paper
        sx={{
          padding: "0px 16px 8px 16px",
          marginBottom: "0px !important",
        }}
      >
        <h4>{"Security PDC Details"}</h4>
        <Grid container rowSpacing={0} columnSpacing={1}>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              type="number"
              label="Start Cheque Number"
              variant="standard"
              disabled={false}
              required={true}
              value={chequeDetailData.startChequeNumber}
              placeholder="Please Enter Start Cheque Number"
              onBlur={(e) => {
                onChangeChequeNumber();
              }}
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
                style: { textAlign: `left`, fontSize: "12px" },
              }}
              onChange={(event) => {
                if (event.target.value.length <= 6) {
                  dispatch(
                    SecurityChequeReducerAction.updateStartChequeNumber(
                      event.target.value ? event.target.value : ""
                    )
                  );
                  const newValue = event.target.value;
                  setChequeNumErrorMsg(
                    newValue === null ||
                      newValue === undefined ||
                      newValue === ""
                      ? "Please Enter Start Cheque Number"
                      : newValue.length > 6 ||
                        newValue.length < 6 ||
                        String(newValue).includes(".") ||
                        Number(newValue) < 0
                      ? "Please Enter Valid Cheque Number"
                      : ""
                  );
                } else {
                  return;
                }
              }}
            ></CustomTextField>
            {chequeNumHasError && <p className="error">{chequeNumErrorMsg}</p>}
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomDateField
              type="Cheque Date"
              label="Start Cheque Date"
              variant="standard"
              disabled={true}
              value={chequeDetailData.startChequeDate}
            ></CustomDateField>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              type="number"
              label="Number Of Cheques"
              variant="standard"
              disabled={false}
              required={true}
              placeholder="Please Enter Number Of Cheques"
              value={chequeDetailData.noOfCheque}
              onBlur={(e) => {
                onChangeNumberOfCheques();
              }}
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
                style: { textAlign: `left`, fontSize: "12px" },
              }}
              onChange={(event) => {
                if (event.target.value.length < 3) {
                  dispatch(
                    SecurityChequeReducerAction.updateNumberOfCheques(
                      event.target.value ? event.target.value : ""
                    )
                  );
                  const newValue = event.target.value;
                  setNumberOfChequesErrorMsg(
                    newValue === null ||
                      newValue === undefined ||
                      newValue === "" ||
                      Number(newValue) === 0 ||
                      Number(newValue) < 0
                      ? "Please Enter Number of Cheques"
                      : newValue.length > 2 || String(newValue).includes(".")
                      ? "Please Enter Valid Number of Cheques"
                      : ""
                  );
                } else {
                  return;
                }
              }}
            ></CustomTextField>
            {numOfChequesHasError && (
              <p className="error">{noOfChequesErrorMsg}</p>
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomAutoComplete
              disabled={false}
              required={true}
              label="Cheque Type"
              id="chequeType"
              variant="standard"
              type="text"
              placeholder="Select Cheque Type"
              autoCompleteValues={chequeDetailData.chequeTypeArray}
              value={chequeDetailData.chequeType}
              onChange={(event, value) => {
                dispatch(SecurityChequeReducerAction.updateChequeType(value));
              }}
              onBlur={(event, value) => {
                dispatch(
                  SecurityChequeReducerAction.updateChequeTypeIsTouched(true)
                );
              }}
            />
            {chequeTypeHasError && (
              <p className="error">Please Select Cheque Type</p>
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomAutoComplete
              disabled={true}
              required={false}
              label="MICR Type"
              id="micrType"
              variant="standard"
              value={chequeDetailData.micrType}
              type="text"
              placeholder="Select MICR Type."
              autoCompleteValues={chequeDetailData.micrTypeArray}
              onChange={(event, value) => {
                dispatch(
                  SecurityChequeReducerAction.updateMICRTypeValue(value)
                );
              }}
              onBlur={(event, value) => {
                dispatch(
                  SecurityChequeReducerAction.updateMICRTypeIsTouched(true)
                );
              }}
            />
            {micrTypeHasError && (
              <p className="error">Please Select MICR Type</p>
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomAutoComplete
              disabled={false}
              required={true}
              label="Bank Option"
              id="bankoption"
              variant="standard"
              value={chequeDetailData.bankOption}
              type="text"
              placeholder="Select Bank Option Type"
              autoCompleteValues={chequeDetailData.bankOptionArray}
              onChange={(event, value) => {
                dispatch(
                  SecurityChequeReducerAction.updateBankOptionValue(value)
                );
                onChangeBankOption(value);
              }}
              onBlur={(event, value) => {
                dispatch(
                  SecurityChequeReducerAction.updateBankOptionIsTouched(true)
                );
              }}
            />
            {bankOptionTypeHasError && (
              <p className="error">Please Select Bank Option</p>
            )}
          </Grid>
          {chequeDetailData.micrType === "MICR" && (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                type="number"
                label="MICR"
                variant="standard"
                required={true}
                placeholder="Please Enter MICR Number"
                value={chequeDetailData.micrNumber}
                inputProps={{
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                  style: { textAlign: `left`, fontSize: "12px" },
                }}
                onChange={(event, value) => {
                  const newValue = event.target.value;
                  if (newValue.length <= 9) {
                    dispatch(
                      SecurityChequeReducerAction.updateMICRValue(newValue)
                    );
                  } else {
                    return;
                  }
                }}
                onBlur={(event, value) => {
                  dispatch(SecurityChequeReducerAction.updateMICRTouched(true));
                }}
              ></CustomTextField>
              {micrNumberHasError && (
                <p className="error">Please Enter Valid MICR Number</p>
              )}
            </Grid>
          )}
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomAutoComplete
              variant="standard"
              type="text"
              placeholder="Select Drawee Bank"
              label="Drawee Bank"
              disabled={chequeDetailData.bankOption === "PRIMARY"}
              required={true}
              autoCompleteValues={chequeDetailData.drawerBankArray}
              value={chequeDetailData.drawerBank}
              onChange={(event, value) => {
                dispatch(
                  SecurityChequeReducerAction.updateDraweeBankValue(value)
                );
                onChangeDraweerBank(value);
              }}
              onBlur={(event, value) => {
                dispatch(
                  SecurityChequeReducerAction.updateDraweeBankIsTouched(true)
                );
              }}
            />
            {drawerBankHasError && (
              <p className="error">Please Select Drawee Bank</p>
            )}
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomAutoComplete
              variant="standard"
              type="text"
              placeholder="Select Drawee Branch"
              label="Drawee Branch"
              disabled={chequeDetailData.bankOption === "PRIMARY"}
              required={true}
              autoCompleteValues={chequeDetailData.drawerBranchArray}
              value={chequeDetailData.drawerBranch}
              onChange={(event, value) => {
                dispatch(
                  SecurityChequeReducerAction.updateDraweeBranchValue(value)
                );
              }}
              onBlur={(event, value) => {
                dispatch(
                  SecurityChequeReducerAction.updateDraweeBranchIsTouched(true)
                );
              }}
            />
            {drawerBranchHasError && (
              <p className="error">Please Select Drawee Branch</p>
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              type="text"
              label="IFSC"
              variant="standard"
              disabled={chequeDetailData.bankOption === "PRIMARY"}
              required={true}
              placeholder="Please Enter IFSC"
              value={chequeDetailData.ifsc}
              onChange={(event, value) => {
                const newValue = event.target.value;
                if (newValue.length <= 11) {
                  dispatch(
                    SecurityChequeReducerAction.updateIFSCValue(newValue)
                  );
                } else {
                  return;
                }
              }}
              onBlur={(event, value) => {
                dispatch(SecurityChequeReducerAction.updateIFSCIsTouched(true));
              }}
            ></CustomTextField>
            {ifscHasError && <p className="error">Please Enter Valid IFSC</p>}
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              label="Account Number"
              variant="standard"
              disabled={chequeDetailData.bankOption === "PRIMARY"}
              required={true}
              placeholder="Please Enter Account Number"
              value={chequeDetailData.accNumber}
              type="number"
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
                style: { textAlign: `left`, fontSize: "12px" },
              }}
              onChange={(event, value) => {
                if (event.target.value.length <= 18) {
                  removeUnwantedChars(event.target.value, "accNumber");
                } else {
                  return;
                }
              }}
              onBlur={(event, value) => {
                dispatch(
                  SecurityChequeReducerAction.updateAccountNumIsTouched(true)
                );
              }}
            ></CustomTextField>
            {accNumHasError && (
              <p className="error">Please Enter Valid Account Number</p>
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              type="text"
              label="Account Holder Name"
              variant="standard"
              disabled={chequeDetailData.bankOption === "PRIMARY"}
              required={true}
              placeholder="Please Enter Account Holder Name"
              value={chequeDetailData.accHolderName}
              onChange={(event, value) => {
                const newValue = event.target.value;
                dispatch(
                  SecurityChequeReducerAction.updateAccountHolderNameValue(
                    newValue
                  )
                );
              }}
              onBlur={(event, value) => {
                dispatch(
                  SecurityChequeReducerAction.updateAccountHolderNameIsTouched(
                    true
                  )
                );
              }}
            ></CustomTextField>
            {accHolderNameHasError && (
              <p className="error">Please Enter Valid Account Holder Name</p>
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              type="text"
              label="Repayment Amount"
              variant="standard"
              disabled={true}
              required={false}
              placeholder="Please Enter Repayment Amount"
              value={
                chequeDetailData.repayAmt === "0"
                  ? 0
                  : parseInt(chequeDetailData.repayAmt).toLocaleString("en-IN")
              }
              onChange={(event, value) => {
                dispatch(
                  SecurityChequeReducerAction.updateRepayAmt(
                    event.target.value
                      ? event.target.value.replaceAll(",", "")
                      : 0
                  )
                );
              }}
              onBlur={() => {
                dispatch(
                  SecurityChequeReducerAction.updateRepayAmtTouchHandler(true)
                );
              }}
            ></CustomTextField>
            {repayAmtHasError && (
              <p className="error">Please Enter Repayment Amount</p>
            )}
          </Grid>

          {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              type="text"
              label="Cheque Amount"
              variant="standard"
              disabled={true}
              required={false}
              placeholder="Please Enter Cheque Amount"
              value={
                chequeDetailData.chequeAmt === "0"
                  ? 0
                  : parseInt(chequeDetailData.chequeAmt).toLocaleString("en-IN")
              }
              onChange={(event, value) => {
                dispatch(
                  SecurityChequeReducerAction.updateChequeAmt(
                    event.target.value
                      ? event.target.value.replaceAll(",", "")
                      : 0
                  )
                );
              }}
              onBlur={() => {
                dispatch(
                  SecurityChequeReducerAction.updateChequeAmtTouchHandler(true)
                );
              }}
            ></CustomTextField>
            {chequeAmtHasError && (
              <p className="error">Please Enter Cheque Amount</p>
            )}
          </Grid> */}
        </Grid>
        <Snackbar
          open={alert}
          autoHideDuration={6000}
          anchorOrigin={{ vertical, horizontal }}
          onClose={closeAlertHandler}
        >
          <Alert
            onClose={closeAlertHandler}
            severity={alertType}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {message}
          </Alert>
        </Snackbar>

        <Dialog
          open={open}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>{dialogTitleMessage}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {dialogMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Tooltip title="" placement="top">
              <Button onClick={handleClose} ref={""}>
                Cancel
              </Button>
            </Tooltip>
            <Tooltip title="" placement="top">
              <Button onClick={handleOk} ref={""}>
                Yes
              </Button>
            </Tooltip>
          </DialogActions>
        </Dialog>
      </Paper>
    </React.Fragment>
  );
};

export default SecurityChequeInfo;
